// M13.5 — builds the /app/exports href with the current bounds-first
// URL state preserved. Lives in its own file so ReportOverview.tsx can
// keep `react-refresh/only-export-components` clean, and so vitest can
// unit-test the URL builder without pulling client-only fetch code into
// the worker tsconfig project.

// Mirrors `ReportCompare` from src/client/lib/api.ts but locally
// declared so this helper has no transitive client-only imports.
type CompareKind = "previous" | "year_over_year" | "none" | "custom";

interface ExportsHrefArgs {
  startDate: string;
  endDate: string;
  compare: CompareKind;
  compareStart?: string | null;
  compareEnd?: string | null;
}

export function buildExportsHref(args: ExportsHrefArgs): string {
  const params = new URLSearchParams({
    start: args.startDate,
    end: args.endDate,
    compare: args.compare,
  });
  // compareStart / compareEnd are only meaningful when the user picked
  // a custom compare window (M12.12). Every other compare mode derives
  // its window from the current bounds, so attaching them would just
  // create dead URL noise.
  if (args.compare === "custom") {
    if (args.compareStart) params.set("compareStart", args.compareStart);
    if (args.compareEnd) params.set("compareEnd", args.compareEnd);
  }
  return `/app/exports?${params.toString()}`;
}
